"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dom = _interopRequireDefault(require("./dom.js"));

var _util = _interopRequireDefault(require("./util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @fileoverview
 * @suppress {reportUnknownTypes}
 */

/**
 * Generate a filenamePrefix of hostname_YYYY-MM-DD_HH-MM-SS
 * Date/time uses the local timezone, however Node has unreliable ICU
 * support, so we must construct a YYYY-MM-DD date format manually. :/
 * @param {{finalUrl: string, fetchTime: string}} lhr
 * @return {string}
 */
function getFilenamePrefix(lhr) {
  var hostname = new (getUrlConstructor())(lhr.finalUrl).hostname;
  var date = lhr.fetchTime && new Date(lhr.fetchTime) || new Date();
  var timeStr = date.toLocaleTimeString("en-US", {
    hour12: false
  });
  var dateParts = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).split("/"); // @ts-ignore - parts exists

  dateParts.unshift(dateParts.pop());
  var dateStr = dateParts.join("-");
  var filenamePrefix = "".concat(hostname, "_").concat(dateStr, "_").concat(timeStr); // replace characters that are unfriendly to filenames

  return filenamePrefix.replace(/[/?<>\\:*|":]/g, "-");
}

function getUrlConstructor() {
  return URL;
}
/* eslint-disable no-restricted-globals */

/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


'use strict';
/* eslint-env browser */

/**
 * @fileoverview Adds tools button, print, and other dynamic functionality to
 * the report.
 */

/* globals getFilenamePrefix Util */

/**
 * @param {HTMLTableElement} tableEl
 * @return {Array<HTMLTableRowElement>}
 */


function getTableRows(tableEl) {
  return Array.from(tableEl.tBodies[0].rows);
}

var ReportUIFeatures =
/*#__PURE__*/
function () {
  /**
   * @param {DOM} dom
   */
  function ReportUIFeatures(dom) {
    _classCallCheck(this, ReportUIFeatures);

    /** @type {LH.Result} */
    this.json; // eslint-disable-line no-unused-expressions

    /** @type {DOM} */

    this._dom = dom;
    /** @type {Document} */

    this._document = this._dom.document();
    /** @type {ParentNode} */

    this._templateContext = this._dom.document();
    /** @type {boolean} */

    this._copyAttempt = false;
    /** @type {HTMLElement} */

    this.toolsButton; // eslint-disable-line no-unused-expressions

    /** @type {HTMLElement} */

    this.topbarEl; // eslint-disable-line no-unused-expressions

    /** @type {HTMLElement} */

    this.scoreScaleEl; // eslint-disable-line no-unused-expressions

    /** @type {HTMLElement} */

    this.stickyHeaderEl; // eslint-disable-line no-unused-expressions

    /** @type {HTMLElement} */

    this.highlightEl; // eslint-disable-line no-unused-expressions

    this.onMediaQueryChange = this.onMediaQueryChange.bind(this);
    this.onCopy = this.onCopy.bind(this);
    this.onToolsButtonClick = this.onToolsButtonClick.bind(this);
    this.onToolAction = this.onToolAction.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onChevronClick = this.onChevronClick.bind(this);
    this.collapseAllDetails = this.collapseAllDetails.bind(this);
    this.expandAllDetails = this.expandAllDetails.bind(this);
    this._toggleDarkTheme = this._toggleDarkTheme.bind(this);
    this._updateStickyHeaderOnScroll = this._updateStickyHeaderOnScroll.bind(this);
  }
  /**
   * Adds tools button, print, and other functionality to the report. The method
   * should be called whenever the report needs to be re-rendered.
   * @param {LH.Result} report
   */


  _createClass(ReportUIFeatures, [{
    key: "initFeatures",
    value: function initFeatures(report) {
      var _this = this;

      this.json = report;

      this._setupMediaQueryListeners();

      this._setupToolsButton();

      this._setupThirdPartyFilter();

      this._setUpCollapseDetailsAfterPrinting();

      this._resetUIState();

      this._document.addEventListener('keyup', this.onKeyUp);

      this._document.addEventListener('copy', this.onCopy);

      var topbarLogo = this._dom.find('.lh-topbar__logo', this._document);

      topbarLogo.addEventListener('click', function () {
        return _this._toggleDarkTheme();
      });
      var turnOffTheLights = false; // Do not query the system preferences for DevTools - DevTools should only apply dark theme
      // if dark is selected in the settings panel.

      if (!this._dom.isDevTools() && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        turnOffTheLights = true;
      } // Fireworks.


      var scoresAll100 = Object.values(report.categories).every(function (cat) {
        return cat.score === 1;
      });
      var hasAllCoreCategories = Object.keys(report.categories).filter(function (id) {
        return !_util["default"].isPluginCategory(id);
      }).length >= 5;

      if (scoresAll100 && hasAllCoreCategories) {
        turnOffTheLights = true;

        this._enableFireworks();
      }

      if (turnOffTheLights) {
        this._toggleDarkTheme(true);
      } // There is only a sticky header when at least 2 categories are present.


      if (Object.keys(this.json.categories).length >= 2) {
        this._setupStickyHeaderElements();

        var containerEl = this._dom.find('.lh-container', this._document);

        var elToAddScrollListener = this._getScrollParent(containerEl);

        elToAddScrollListener.addEventListener('scroll', this._updateStickyHeaderOnScroll); // Use ResizeObserver where available.
        // TODO: there is an issue with incorrect position numbers and, as a result, performance
        // issues due to layout thrashing.
        // See https://github.com/GoogleChrome/lighthouse/pull/9023/files#r288822287 for details.
        // For now, limit to DevTools.

        if (this._dom.isDevTools()) {
          var resizeObserver = new window.ResizeObserver(this._updateStickyHeaderOnScroll);
          resizeObserver.observe(containerEl);
        } else {
          window.addEventListener('resize', this._updateStickyHeaderOnScroll);
        }
      } // Show the metric descriptions by default when there is an error.


      var hasMetricError = report.categories.performance && report.categories.performance.auditRefs.some(function (audit) {
        return Boolean(audit.group === 'metrics' && report.audits[audit.id].errorMessage);
      });

      if (hasMetricError) {
        var toggleInputEl =
        /** @type {HTMLInputElement} */
        this._dom.find('.lh-metrics-toggle__input', this._document);

        toggleInputEl.checked = true;
      }
    }
    /**
     * Define a custom element for <templates> to be extracted from. For example:
     *     this.setTemplateContext(new DOMParser().parseFromString(htmlStr, 'text/html'))
     * @param {ParentNode} context
     */

  }, {
    key: "setTemplateContext",
    value: function setTemplateContext(context) {
      this._templateContext = context;
    }
    /**
     * Finds the first scrollable ancestor of `element`. Falls back to the document.
     * @param {HTMLElement} element
     * @return {Node}
     */

  }, {
    key: "_getScrollParent",
    value: function _getScrollParent(element) {
      var _window$getComputedSt = window.getComputedStyle(element),
          overflowY = _window$getComputedSt.overflowY;

      var isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';

      if (isScrollable) {
        return element;
      }

      if (element.parentElement) {
        return this._getScrollParent(element.parentElement);
      }

      return document;
    }
  }, {
    key: "_enableFireworks",
    value: function _enableFireworks() {
      var scoresContainer = this._dom.find('.lh-scores-container', this._document);

      scoresContainer.classList.add('score100');
      scoresContainer.addEventListener('click', function (_) {
        scoresContainer.classList.toggle('fireworks-paused');
      });
    }
    /**
     * Fires a custom DOM event on target.
     * @param {string} name Name of the event.
     * @param {Node=} target DOM node to fire the event on.
     * @param {*=} detail Custom data to include.
     */

  }, {
    key: "_fireEventOn",
    value: function _fireEventOn(name) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._document;
      var detail = arguments.length > 2 ? arguments[2] : undefined;
      var event = new CustomEvent(name, detail ? {
        detail: detail
      } : undefined);
      target.dispatchEvent(event);
    }
  }, {
    key: "_setupMediaQueryListeners",
    value: function _setupMediaQueryListeners() {
      var mediaQuery = self.matchMedia('(max-width: 500px)');
      mediaQuery.addListener(this.onMediaQueryChange); // Ensure the handler is called on init

      this.onMediaQueryChange(mediaQuery);
    }
    /**
     * Handle media query change events.
     * @param {MediaQueryList|MediaQueryListEvent} mql
     */

  }, {
    key: "onMediaQueryChange",
    value: function onMediaQueryChange(mql) {
      var root = this._dom.find('.lh-root', this._document);

      root.classList.toggle('lh-narrow', mql.matches);
    }
  }, {
    key: "_setupToolsButton",
    value: function _setupToolsButton() {
      this.toolsButton = this._dom.find('.lh-tools__button', this._document);
      this.toolsButton.addEventListener('click', this.onToolsButtonClick);

      var dropdown = this._dom.find('.lh-tools__dropdown', this._document);

      dropdown.addEventListener('click', this.onToolAction);
    }
  }, {
    key: "_setupThirdPartyFilter",
    value: function _setupThirdPartyFilter() {
      var _this2 = this;

      // Some audits should not display the third party filter option.
      var thirdPartyFilterAuditExclusions = [// This audit deals explicitly with third party resources.
      'uses-rel-preconnect']; // Get all tables with a text url column.

      /** @type {Array<HTMLTableElement>} */

      var tables = Array.from(this._document.querySelectorAll('.lh-table'));
      var tablesWithUrls = tables.filter(function (el) {
        return el.querySelector('td.lh-table-column--url');
      }).filter(function (el) {
        var containingAudit = el.closest('.lh-audit');
        if (!containingAudit) throw new Error('.lh-table not within audit');
        return !thirdPartyFilterAuditExclusions.includes(containingAudit.id);
      });
      tablesWithUrls.forEach(function (tableEl, index) {
        var urlItems = _this2._getUrlItems(tableEl);

        var thirdPartyRows = _this2._getThirdPartyRows(tableEl, urlItems, _this2.json.finalUrl); // create input box


        var filterTemplate = _this2._dom.cloneTemplate('#tmpl-lh-3p-filter', _this2._templateContext);

        var filterInput =
        /** @type {HTMLInputElement} */
        _this2._dom.find('input', filterTemplate);

        var id = "lh-3p-filter-label--".concat(index);
        filterInput.id = id;
        filterInput.addEventListener('change', function (e) {
          // Remove rows from the dom and keep track of them to re-add on uncheck.
          // Why removing instead of hiding? To keep nth-child(even) background-colors working.
          if (e.target instanceof HTMLInputElement && !e.target.checked) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = thirdPartyRows.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var row = _step.value;
                row.remove();
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          } else {
            // Add row elements back to original positions.
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = thirdPartyRows.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                    position = _step2$value[0],
                    _row = _step2$value[1];

                var childrenArr = getTableRows(tableEl);
                tableEl.tBodies[0].insertBefore(_row, childrenArr[position]);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                  _iterator2["return"]();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        });

        _this2._dom.find('label', filterTemplate).setAttribute('for', id);

        _this2._dom.find('.lh-3p-filter-count', filterTemplate).textContent = "".concat(thirdPartyRows.size);
        _this2._dom.find('.lh-3p-ui-string', filterTemplate).textContent = _util["default"].UIStrings.thirdPartyResourcesLabel; // If all or none of the rows are 3rd party, disable the checkbox.

        if (thirdPartyRows.size === urlItems.length || !thirdPartyRows.size) {
          filterInput.disabled = true;
          filterInput.checked = thirdPartyRows.size === urlItems.length;
        } // Finally, add checkbox to the DOM.


        if (!tableEl.parentNode) return; // Keep tsc happy.

        tableEl.parentNode.insertBefore(filterTemplate, tableEl);
      });
    }
    /**
     * From a table with URL entries, finds the rows containing third-party URLs
     * and returns a Map of those rows, mapping from row index to row Element.
     * @param {HTMLTableElement} el
     * @param {string} finalUrl
     * @param {Array<HTMLElement>} urlItems
     * @return {Map<number, HTMLTableRowElement>}
     */

  }, {
    key: "_getThirdPartyRows",
    value: function _getThirdPartyRows(el, urlItems, finalUrl) {
      var finalUrlRootDomain = _util["default"].getRootDomain(finalUrl);
      /** @type {Map<number, HTMLTableRowElement>} */


      var thirdPartyRows = new Map();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = urlItems[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var urlItem = _step3.value;
          var datasetUrl = urlItem.dataset.url;
          if (!datasetUrl) continue;
          var isThirdParty = _util["default"].getRootDomain(datasetUrl) !== finalUrlRootDomain;
          if (!isThirdParty) continue;
          var urlRowEl = urlItem.closest('tr');

          if (urlRowEl) {
            var rowPosition = getTableRows(el).indexOf(urlRowEl);
            thirdPartyRows.set(rowPosition, urlRowEl);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return thirdPartyRows;
    }
    /**
     * From a table, finds and returns URL items.
     * @param {HTMLTableElement} tableEl
     * @return {Array<HTMLElement>}
     */

  }, {
    key: "_getUrlItems",
    value: function _getUrlItems(tableEl) {
      return this._dom.findAll('.lh-text__url', tableEl);
    }
  }, {
    key: "_setupStickyHeaderElements",
    value: function _setupStickyHeaderElements() {
      this.topbarEl = this._dom.find('.lh-topbar', this._document);
      this.scoreScaleEl = this._dom.find('.lh-scorescale', this._document);
      this.stickyHeaderEl = this._dom.find('.lh-sticky-header', this._document); // Highlighter will be absolutely positioned at first gauge, then transformed on scroll.

      this.highlightEl = this._dom.createChildOf(this.stickyHeaderEl, 'div', 'lh-highlighter');
    }
    /**
     * Handle copy events.
     * @param {ClipboardEvent} e
     */

  }, {
    key: "onCopy",
    value: function onCopy(e) {
      // Only handle copy button presses (e.g. ignore the user copying page text).
      if (this._copyAttempt && e.clipboardData) {
        // We want to write our own data to the clipboard, not the user's text selection.
        e.preventDefault();
        e.clipboardData.setData('text/plain', JSON.stringify(this.json, null, 2));

        this._fireEventOn('lh-log', this._document, {
          cmd: 'log',
          msg: 'Report JSON copied to clipboard'
        });
      }

      this._copyAttempt = false;
    }
    /**
     * Copies the report JSON to the clipboard (if supported by the browser).
     */

  }, {
    key: "onCopyButtonClick",
    value: function onCopyButtonClick() {
      this._fireEventOn('lh-analytics', this._document, {
        cmd: 'send',
        fields: {
          hitType: 'event',
          eventCategory: 'report',
          eventAction: 'copy'
        }
      });

      try {
        if (this._document.queryCommandSupported('copy')) {
          this._copyAttempt = true; // Note: In Safari 10.0.1, execCommand('copy') returns true if there's
          // a valid text selection on the page. See http://caniuse.com/#feat=clipboard.

          if (!this._document.execCommand('copy')) {
            this._copyAttempt = false; // Prevent event handler from seeing this as a copy attempt.

            this._fireEventOn('lh-log', this._document, {
              cmd: 'warn',
              msg: 'Your browser does not support copy to clipboard.'
            });
          }
        }
      } catch (
      /** @type {Error} */
      e) {
        this._copyAttempt = false;

        this._fireEventOn('lh-log', this._document, {
          cmd: 'log',
          msg: e.message
        });
      }
    }
  }, {
    key: "onChevronClick",
    value: function onChevronClick() {
      var toggle = this._dom.find('.lh-config__settings-toggle', this._document);

      if (toggle.hasAttribute('open')) {
        toggle.removeAttribute('open');
      } else {
        toggle.setAttribute('open', 'true');
      }
    }
  }, {
    key: "closeToolsDropdown",
    value: function closeToolsDropdown() {
      this.toolsButton.classList.remove('active');
    }
    /**
     * Click handler for tools button.
     * @param {Event} e
     */

  }, {
    key: "onToolsButtonClick",
    value: function onToolsButtonClick(e) {
      e.preventDefault();
      this.toolsButton.classList.toggle('active');

      this._document.addEventListener('keydown', this.onKeyDown);
    }
    /**
     * Resets the state of page before capturing the page for export.
     * When the user opens the exported HTML page, certain UI elements should
     * be in their closed state (not opened) and the templates should be unstamped.
     */

  }, {
    key: "_resetUIState",
    value: function _resetUIState() {
      this.closeToolsDropdown();

      this._dom.resetTemplates();
    }
    /**
     * Handler for tool button.
     * @param {Event} e
     */

  }, {
    key: "onToolAction",
    value: function onToolAction(e) {
      e.preventDefault();
      var el =
      /** @type {?Element} */
      e.target;

      if (!el || !el.hasAttribute('data-action')) {
        return;
      }

      switch (el.getAttribute('data-action')) {
        case 'copy':
          this.onCopyButtonClick();
          break;

        case 'print-summary':
          this.collapseAllDetails();
          this.closeToolsDropdown();

          this._print();

          break;

        case 'print-expanded':
          this.expandAllDetails();
          this.closeToolsDropdown();

          this._print();

          break;

        case 'save-json':
          {
            var jsonStr = JSON.stringify(this.json, null, 2);

            this._saveFile(new Blob([jsonStr], {
              type: 'application/json'
            }));

            break;
          }

        case 'save-html':
          {
            var htmlStr = this.getReportHtml();

            try {
              this._saveFile(new Blob([htmlStr], {
                type: 'text/html'
              }));
            } catch (
            /** @type {Error} */
            e) {
              this._fireEventOn('lh-log', this._document, {
                cmd: 'error',
                msg: 'Could not export as HTML. ' + e.message
              });
            }

            break;
          }

        case 'open-viewer':
          {
            var viewerPath = '/lighthouse/viewer/';
            ReportUIFeatures.openTabAndSendJsonReport(this.json, viewerPath);
            break;
          }

        case 'save-gist':
          {
            this.saveAsGist();
            break;
          }

        case 'toggle-dark':
          {
            this._toggleDarkTheme();

            break;
          }
      }

      this.closeToolsDropdown();

      this._document.removeEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "_print",
    value: function _print() {
      self.print();
    }
    /**
     * Keydown handler for the document.
     * @param {KeyboardEvent} e
     */

  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (e.keyCode === 27) {
        // ESC
        this.closeToolsDropdown();
      }
    }
    /**
     * Keyup handler for the document.
     * @param {KeyboardEvent} e
     */

  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      // Ctrl+P - Expands audit details when user prints via keyboard shortcut.
      if ((e.ctrlKey || e.metaKey) && e.keyCode === 80) {
        this.closeToolsDropdown();
      }
    }
    /**
     * Opens a new tab to the online viewer and sends the local page's JSON results
     * to the online viewer using postMessage.
     * @param {LH.Result} reportJson
     * @param {string} viewerPath
     * @protected
     */

  }, {
    key: "expandAllDetails",

    /**
     * Expands all audit `<details>`.
     * Ideally, a print stylesheet could take care of this, but CSS has no way to
     * open a `<details>` element.
     */
    value: function expandAllDetails() {
      var details =
      /** @type {Array<HTMLDetailsElement>} */
      this._dom.findAll('.lh-categories details', this._document);

      details.map(function (detail) {
        return detail.open = true;
      });
    }
    /**
     * Collapses all audit `<details>`.
     * open a `<details>` element.
     */

  }, {
    key: "collapseAllDetails",
    value: function collapseAllDetails() {
      var details =
      /** @type {Array<HTMLDetailsElement>} */
      this._dom.findAll('.lh-categories details', this._document);

      details.map(function (detail) {
        return detail.open = false;
      });
    }
    /**
     * Sets up listeners to collapse audit `<details>` when the user closes the
     * print dialog, all `<details>` are collapsed.
     */

  }, {
    key: "_setUpCollapseDetailsAfterPrinting",
    value: function _setUpCollapseDetailsAfterPrinting() {
      var _this3 = this;

      // FF and IE implement these old events.
      if ('onbeforeprint' in self) {
        self.addEventListener('afterprint', this.collapseAllDetails);
      } else {
        var win =
        /** @type {Window} */
        self; // Note: FF implements both window.onbeforeprint and media listeners. However,
        // it doesn't matchMedia doesn't fire when matching 'print'.

        win.matchMedia('print').addListener(function (mql) {
          if (mql.matches) {
            _this3.expandAllDetails();
          } else {
            _this3.collapseAllDetails();
          }
        });
      }
    }
    /**
     * Returns the html that recreates this report.
     * @return {string}
     * @protected
     */

  }, {
    key: "getReportHtml",
    value: function getReportHtml() {
      this._resetUIState();

      return this._document.documentElement.outerHTML;
    }
    /**
     * Save json as a gist. Unimplemented in base UI features.
     * @protected
     */

  }, {
    key: "saveAsGist",
    value: function saveAsGist() {
      throw new Error('Cannot save as gist from base report');
    }
    /**
     * Downloads a file (blob) using a[download].
     * @param {Blob|File} blob The file to save.
     * @private
     */

  }, {
    key: "_saveFile",
    value: function _saveFile(blob) {
      var filename = getFilenamePrefix({
        finalUrl: this.json.finalUrl,
        fetchTime: this.json.fetchTime
      });
      var ext = blob.type.match('json') ? '.json' : '.html';
      var href = URL.createObjectURL(blob);

      var a = this._dom.createElement('a');

      a.download = "".concat(filename).concat(ext);
      a.href = href;

      this._document.body.appendChild(a); // Firefox requires anchor to be in the DOM.


      a.click(); // cleanup.

      this._document.body.removeChild(a);

      setTimeout(function (_) {
        return URL.revokeObjectURL(href);
      }, 500);
    }
    /**
     * @private
     * @param {boolean} [force]
     */

  }, {
    key: "_toggleDarkTheme",
    value: function _toggleDarkTheme(force) {
      var el = this._dom.find('.lh-vars', this._document); // This seems unnecessary, but in DevTools, passing "undefined" as the second
      // parameter acts like passing "false".
      // https://github.com/ChromeDevTools/devtools-frontend/blob/dd6a6d4153647c2a4203c327c595692c5e0a4256/front_end/dom_extension/DOMExtension.js#L809-L819


      if (typeof force === 'undefined') {
        el.classList.toggle('dark');
      } else {
        el.classList.toggle('dark', force);
      }
    }
  }, {
    key: "_updateStickyHeaderOnScroll",
    value: function _updateStickyHeaderOnScroll() {
      // Show sticky header when the score scale begins to go underneath the topbar.
      var topbarBottom = this.topbarEl.getBoundingClientRect().bottom;
      var scoreScaleTop = this.scoreScaleEl.getBoundingClientRect().top;
      var showStickyHeader = topbarBottom >= scoreScaleTop; // Highlight mini gauge when section is in view.
      // In view = the last category that starts above the middle of the window.

      var categoryEls = Array.from(this._document.querySelectorAll('.lh-category'));
      var categoriesAboveTheMiddle = categoryEls.filter(function (el) {
        return el.getBoundingClientRect().top - window.innerHeight / 2 < 0;
      });
      var highlightIndex = categoriesAboveTheMiddle.length > 0 ? categoriesAboveTheMiddle.length - 1 : 0; // Category order matches gauge order in sticky header.

      var gaugeWrapperEls = this.stickyHeaderEl.querySelectorAll('.lh-gauge__wrapper');
      var gaugeToHighlight = gaugeWrapperEls[highlightIndex];
      var origin = gaugeWrapperEls[0].getBoundingClientRect().left;
      var offset = gaugeToHighlight.getBoundingClientRect().left - origin; // Mutate at end to avoid layout thrashing.

      this.highlightEl.style.transform = "translate(".concat(offset, "px)");
      this.stickyHeaderEl.classList.toggle('lh-sticky-header--visible', showStickyHeader);
    }
  }], [{
    key: "openTabAndSendJsonReport",
    value: function openTabAndSendJsonReport(reportJson, viewerPath) {
      var VIEWER_ORIGIN = 'https://googlechrome.github.io'; // Chrome doesn't allow us to immediately postMessage to a popup right
      // after it's created. Normally, we could also listen for the popup window's
      // load event, however it is cross-domain and won't fire. Instead, listen
      // for a message from the target app saying "I'm open".

      var json = reportJson;
      window.addEventListener('message', function msgHandler(messageEvent) {
        if (messageEvent.origin !== VIEWER_ORIGIN) {
          return;
        }

        if (popup && messageEvent.data.opened) {
          popup.postMessage({
            lhresults: json
          }, VIEWER_ORIGIN);
          window.removeEventListener('message', msgHandler);
        }
      }); // The popup's window.name is keyed by version+url+fetchTime, so we reuse/select tabs correctly
      // @ts-ignore - If this is a v2 LHR, use old `generatedTime`.

      var fallbackFetchTime =
      /** @type {string} */
      json.generatedTime;
      var fetchTime = json.fetchTime || fallbackFetchTime;
      var windowName = "".concat(json.lighthouseVersion, "-").concat(json.requestedUrl, "-").concat(fetchTime);
      var popup = window.open("".concat(VIEWER_ORIGIN).concat(viewerPath), windowName);
    }
  }]);

  return ReportUIFeatures;
}(); // if (typeof module !== 'undefined' && module.exports) {
//   module.exports = ReportUIFeatures;
// } else {
//   self.ReportUIFeatures = ReportUIFeatures;
// }


var _default = ReportUIFeatures;
exports["default"] = _default;